import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { RedeemVoucher } from './RedeemVoucher';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export const ClientSettings = () => {
  const { user } = useAuth();

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-brand-navy">Account Settings</h1>
        <p className="text-slate-600">Manage your profile and subscription</p>
      </div>

      {/* Profile Card */}
      <div className="bg-white border border-slate-200 rounded-xl p-6">
        <h2 className="font-semibold text-brand-navy mb-4 flex items-center gap-2">
          <SafeIcon icon={FiIcons.FiUser} className="text-slate-500" />
          Profile Information
        </h2>
        <div className="space-y-3">
          {[
            { label: 'Full Name', value: user?.full_name ?? user?.name },
            { label: 'Email Address', value: user?.email },
            { label: 'Account Role', value: user?.role },
          ].map((row) => (
            <div key={row.label} className="flex justify-between py-2 border-b border-slate-100 last:border-0">
              <span className="text-sm text-slate-500">{row.label}</span>
              <span className="text-sm font-medium text-slate-800 capitalize">{row.value}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Subscription Card */}
      <div className="bg-white border border-slate-200 rounded-xl p-6">
        <h2 className="font-semibold text-brand-navy mb-4 flex items-center gap-2">
          <SafeIcon icon={FiIcons.FiStar} className="text-slate-500" />
          Subscription
        </h2>
        <div className="flex items-center justify-between">
          <span className="text-sm text-slate-600">Current Status</span>
          <span className={`px-3 py-1 rounded-full text-xs font-semibold border ${
            user?.subscription_status === 'active'
              ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
              : 'bg-red-50 text-red-700 border-red-200'
          }`}>
            {user?.subscription_status === 'active' ? 'Active' : 'Inactive'}
          </span>
        </div>
        {user?.applied_voucher && (
          <div className="mt-3 flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
            <SafeIcon icon={FiIcons.FiTag} className="text-amber-600 flex-shrink-0" />
            <p className="text-xs text-amber-800">
              Voucher <span className="font-bold">{user.applied_voucher}</span> applied to your account
            </p>
          </div>
        )}
      </div>

      {/* Redeem Voucher */}
      <RedeemVoucher />
    </div>
  );
};